import htmlSvg from "devicon/icons/html5/html5-original.svg";
import cssSvg from "devicon/icons/css3/css3-original.svg";
import sassSvg from "devicon/icons/sass/sass-original.svg";
import jsSvg from "devicon/icons/javascript/javascript-original.svg";
import tsSvg from "devicon/icons/typescript/typescript-original.svg";
import reactSvg from "devicon/icons/react/react-original.svg";
import reduxSvg from "devicon/icons/redux/redux-original.svg";
import cSvg from "devicon/icons/c/c-original.svg";
import cppSvg from "devicon/icons/cplusplus/cplusplus-original.svg";
import csSvg from "devicon/icons/csharp/csharp-original.svg";
import qtSvg from "devicon/icons/qt/qt-original.svg";
import netCoreSvg from "devicon/icons/dotnetcore/dotnetcore-original.svg";
import pythonSvg from "devicon/icons/python/python-original.svg";
import djangoSvg from "devicon/icons/django/django-original.svg";
import expressSvg from "devicon/icons/express/express-original.svg";
import azureSvg from "devicon/icons/azure/azure-original.svg";
import gatsbySvg from "devicon/icons/gatsby/gatsby-original.svg";
import gitSvg from "devicon/icons/git/git-original.svg";
import linuxSvg from "devicon/icons/linux/linux-original.svg";

const languages = [
  {
    label: "HTML",
    icon: htmlSvg,
  },
  {
    label: "CSS",
    icon: cssSvg,
  },
  {
    label: "SASS",
    icon: sassSvg,
  },
  {
    label: "JavaScript",
    icon: jsSvg,
  },
  {
    label: "TypeScript",
    icon: tsSvg,
  },
  {
    label: "React",
    icon: reactSvg,
  },
  {
    label: "React Native",
    icon: reactSvg,
  },
  {
    label: "Redux",
    icon: reduxSvg,
  },
  {
    label: "Express.js",
    icon: expressSvg,
  },
  {
    label: "Gatsby",
    icon: gatsbySvg,
  },
  {
    label: "C",
    icon: cSvg,
  },
  {
    label: "C++",
    icon: cppSvg,
  },
  {
    label: "C#",
    icon: csSvg,
  },
  {
    label: "Qt",
    icon: qtSvg,
  },
  {
    label: ".NET Core",
    icon: netCoreSvg,
  },
  {
    label: "Python",
    icon: pythonSvg,
  },
  {
    label: "Django",
    icon: djangoSvg,
  },
  {
    label: "Azure",
    icon: azureSvg,
  },
  {
    label: "Git",
    icon: gitSvg,
  },
  {
    label: "Linux",
    icon: linuxSvg,
  },
];

export default languages;
